<template>
    <main class="page-body">
        <app-modulecreate
            v-if="editorMode && getPossibleModulesToCreate && items.length === 0"
            v-on:click="openModulecreator().catch(() => {})"
            :on-top="true"
        ></app-modulecreate>

        <app-newsticker></app-newsticker>

        <div class="modules">
            <draggable handle=".modulemove__button--drag" animation="500" @end="dragEnd">
                <div
                    v-for="(items__value, items__key) in items"
                    v-bind:key="items__value.id"
                    v-bind:data-id="items__value.id"
                    v-bind:class="generateClassForModule(items__value.id)"
                >
                    <app-modulemove
                        v-if="editorMode && items.length > 1"
                        :first="items__key <= 0"
                        :last="items__key >= items.length - 1"
                        v-on:move-up="moveUp(items__value)"
                        v-on:move-down="moveDown(items__value)"
                    ></app-modulemove>

                    <app-configbar
                        v-if="editorMode"
                        :show-data="
                            getModuleDataByType(items__value.type).configurator.includes('data')
                        "
                        :show-layout="
                            getModuleDataByType(items__value.type).configurator.includes('layout')
                        "
                        :show-appearance="
                            getModuleDataByType(items__value.type).configurator.includes(
                                'appearance'
                            )
                        "
                        v-on:open="toggleActiveModule(items__value.id, $event)"
                    >
                    </app-configbar>

                    <component v-bind:module="items__value" v-bind:is="'app-' + items__value.type">
                    </component>

                    <app-modulecreate
                        v-if="editorMode && getPossibleModulesToCreate"
                        v-on:click="openModulecreator(items__value.id).catch(() => {})"
                    ></app-modulecreate>
                </div>
            </draggable>
        </div>
    </main>
</template>

<script>
import draggable from 'vuedraggable';
import { toArray } from '@/helpers/utils';
import { mapGetters, mapActions } from 'vuex';

import Modulecreate from '@/components/assorted/Modulecreate.vue';
import Modulemove from '@/components/assorted/Modulemove.vue';
import Configbar from '@/components/assorted/Configbar.vue';
import Newsticker from '@/components/assorted/Newsticker';

import About from '@/components/modules/About.vue';
import AboutWidget from '@/components/modules/AboutWidget.vue';
import Album from '@/components/modules/Album.vue';
import Awards from '@/components/modules/Awards.vue';
import Brands from '@/components/modules/Brands.vue';
import Certifications from '@/components/modules/Certifications.vue';
import Contact from '@/components/modules/Contact.vue';
import ContactWidget from '@/components/modules/ContactWidget.vue';
import ContactForm from '@/components/modules/ContactForm.vue';
import Documents from '@/components/modules/Documents.vue';
import Gallery from '@/components/modules/Gallery.vue';
import ImageSlider from '@/components/modules/ImageSlider.vue';
import ImageText from '@/components/modules/ImageText.vue';
import Imprint from '@/components/modules/Imprint.vue';
import Jobs from '@/components/modules/Jobs.vue';
import JobsWidget from '@/components/modules/JobsWidget.vue';
import Listing from '@/components/modules/Listing.vue';
import News from '@/components/modules/News.vue';
import OpeningTimes from '@/components/modules/OpeningTimes.vue';
import Partners from '@/components/modules/Partners.vue';
import Privacy from '@/components/modules/Privacy.vue';
import References from '@/components/modules/References.vue';
import ReferencesWidget from '@/components/modules/ReferencesWidget.vue';
import Sectors from '@/components/modules/Sectors.vue';
import SectorsWidget from '@/components/modules/SectorsWidget.vue';
import Services from '@/components/modules/Services.vue';
import Socials from '@/components/modules/Socials.vue';
import Team from '@/components/modules/Team.vue';
import TeamWidget from '@/components/modules/TeamWidget.vue';
import TextBox from '@/components/modules/TextBox.vue';
import Video from '@/components/modules/Video.vue';
import Widgets from '@/components/modules/Widgets.vue';

// export module
export default {
    data() {
        return {};
    },
    components: {
        'app-modulecreate': Modulecreate,
        'app-modulemove': Modulemove,
        'app-configbar': Configbar,
        'app-newsticker': Newsticker,

        'app-about': About,
        'app-aboutwidget': AboutWidget,
        'app-album': Album,
        'app-awards': Awards,
        'app-brands': Brands,
        'app-certifications': Certifications,
        'app-contact': Contact,
        'app-contactform': ContactForm,
        'app-contactwidget': ContactWidget,
        'app-documents': Documents,
        'app-gallery': Gallery,
        'app-imageslider': ImageSlider,
        'app-imagetext': ImageText,
        'app-imprint': Imprint,
        'app-jobs': Jobs,
        'app-jobswidget': JobsWidget,
        'app-listing': Listing,
        'app-news': News,
        'app-openingtimes': OpeningTimes,
        'app-partners': Partners,
        'app-privacy': Privacy,
        'app-references': References,
        'app-referenceswidget': ReferencesWidget,
        'app-sectors': Sectors,
        'app-sectorswidget': SectorsWidget,
        'app-services': Services,
        'app-socials': Socials,
        'app-team': Team,
        'app-teamwidget': TeamWidget,
        'app-textbox': TextBox,
        'app-video': Video,
        'app-widgets': Widgets,

        draggable
    },
    methods: {
        ...mapActions([
            'setPosForModule',
            'saveAllData',
            'openModulecreator',
            'scrollVerticalCenterModule'
        ]),
        moduleIsActive(id, configurator_view = null) {
            return (
                this.getActiveModuleId === id &&
                (configurator_view === null || this.getActiveConfiguratorView === configurator_view)
            );
        },
        toggleActiveModule(id, configurator_view) {
            if (!this.moduleIsActive(id, configurator_view)) {
                this.$router.push({
                    name: 'editor',
                    params: {
                        page: this.getActivePageRoute
                    },
                    query: {
                        configurator: 1,
                        configurator_group: 'modules',
                        configurator_view: configurator_view,
                        module_id: id
                    }
                });
                this.scrollVerticalCenterModule({ id: id });
            } else {
                this.$router.push({
                    name: 'editor',
                    params: {
                        page: this.getActivePageRoute
                    }
                });
            }
        },
        async dragEnd(e) {
            await this.setPosForModule({
                id: e.item.getAttribute('data-id'),
                pos: e.newIndex + 1 + (e.newIndex > e.oldIndex ? 0.1 : -0.1)
            });
            await this.saveAllData();
        },
        async moveUp(item) {
            await this.move(item, -1.1);
        },
        async moveDown(item) {
            await this.move(item, 1.1);
        },
        async move(item, offset) {
            /* we keep the current position until the divs have changed order */
            let scrollTop = document.querySelector('.page-wrap').scrollTop;
            let keepPosition = setInterval(() => {
                document.querySelector('.page-wrap').scrollTop = scrollTop;
            }, 10);
            await this.setPosForModule({ id: item.id, pos: item.pos + offset });
            await new Promise((resolve) =>
                setTimeout(() => {
                    if (keepPosition) {
                        clearInterval(keepPosition);
                    }
                    resolve();
                }, 100)
            );
            this.scrollVerticalCenterModule({ id: item.id, delay: 0 });
            await this.saveAllData();
        }
    },
    computed: {
        ...mapGetters([
            'getActiveModuleId',
            'getActiveConfiguratorView',
            'getModules',
            'getActivePageRoute',
            'getActivePageId',
            'editorMode',
            'getPossibleModulesToCreate',
            'generateClassForModule',
            'isModuleDeletable',
            'getModuleDataByType'
        ]),
        items() {
            return toArray(this.getModules)
                .filter((i) => i.page_id == this.getActivePageId)
                .sort((a, b) => a.pos - b.pos);
        }
    },
    created() {},
    props: {}
};
</script>
